import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcRecommendColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2731 6.60084L13.3448 11.1586C13.4449 11.3787 13.6213 11.5551 13.8414 11.6552L18.3992 13.7269C18.6336 13.8335 18.6336 14.1665 18.3992 14.2731L13.8414 16.3448C13.6213 16.4449 13.4449 16.6213 13.3448 16.8414L11.2731 21.3992C11.1665 21.6336 10.8335 21.6336 10.7269 21.3992L8.65518 16.8414C8.55513 16.6213 8.37872 16.4449 8.15861 16.3448L3.60084 14.2731C3.36636 14.1665 3.36636 13.8335 3.60084 13.7269L8.15861 11.6552C8.37872 11.5551 8.55513 11.3787 8.65518 11.1586L10.7269 6.60084C10.8335 6.36636 11.1665 6.36636 11.2731 6.60084Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0948 8.59139L21.1821 10.5994C21.111 10.7558 20.889 10.7558 20.8179 10.5994L19.9052 8.59139C19.8051 8.37128 19.6287 8.19487 19.4086 8.09482L17.4006 7.18207C17.2442 7.11102 17.2442 6.88898 17.4006 6.81793L19.4086 5.90518C19.6287 5.80513 19.8051 5.62872 19.9052 5.40861L20.8179 3.40056C20.889 3.24424 21.111 3.24424 21.1821 3.40056L22.0948 5.40861C22.1949 5.62872 22.3713 5.80513 22.5914 5.90518L24.5994 6.81793C24.7558 6.88898 24.7558 7.11102 24.5994 7.18207L22.5914 8.09482C22.3713 8.19487 22.1949 8.37128 22.0948 8.59139Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9052 19.4086L20.8179 17.4006C20.889 17.2442 21.111 17.2442 21.1821 17.4006L22.0948 19.4086C22.1949 19.6287 22.3713 19.8051 22.5914 19.9052L24.5994 20.8179C24.7558 20.889 24.7558 21.111 24.5994 21.1821L22.5914 22.0948C22.3713 22.1949 22.1949 22.3713 22.0948 22.5914L21.1821 24.5994C21.111 24.7558 20.889 24.7558 20.8179 24.5994L19.9052 22.5914C19.8051 22.3713 19.6287 22.1949 19.4086 22.0948L17.4006 21.1821C17.2442 21.111 17.2442 20.889 17.4006 20.8179L19.4086 19.9052C19.6287 19.8051 19.8051 19.6287 19.9052 19.4086Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcRecommendColor;
